import { render, staticRenderFns } from "./supplier-detail-quoted-log.vue?vue&type=template&id=d0abd4ea&scoped=true&"
import script from "./supplier-detail-quoted-log.vue?vue&type=script&lang=js&"
export * from "./supplier-detail-quoted-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0abd4ea",
  null
  
)

export default component.exports